import { Component } from '@angular/core';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.css'],
})
export class PricingComponent {
  pricingList = [
    {
      name: 'Basic',
      price: '500',
      sessions: '1',
      title: 'All basic package includes',
      includes:
        'Gain essential insights to refine your CV and prepare for interviews. This package includes a basic CV review and tailored tips to make your profile stand out. Perfect for beginners entering the job market.',
    },
    {
      name: 'Pro',
      price: '1500',
      sessions: '4',
      title: 'All pro package includes',
      includes:
        'Take your career to the next level with an in-depth CV enhancement, a detailed analysis of your skills, and a mock interview session. Receive comprehensive feedback and strategies to overcome career challenges. Ideal for professionals seeking advancement.',
    },
    {
      name: 'Enterprise',
      price: 'Customized',

      title: 'All enterprise package includes',
      includes:
        'Achieve career excellence with advanced CV optimization tailored to highlight your expertise and accomplishments. Benefit from multiple mock interviews, strategic career coaching, and comprehensive advice for leadership roles. Gain exclusive insights into personal branding and positioning for top-tier opportunities.',
    },
  ];
}
